import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import Institute from "../Layouts/InstituteForm";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { InstituteFormValues } from "src/models/Institute.model";
import { useGetInstituteByIdQuery, useUpdateInstituteByIdMutation } from "src/services/InstituteService";

type Props = {
  onClose: () => void;
  selectedInstituteId: string;
};

const EditinstituteWrapper = ({ onClose, selectedInstituteId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetInstituteByIdQuery(selectedInstituteId);
  const [updateinstituteById] = useUpdateInstituteByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: InstituteFormValues = {
    instituteName: items?.instituteName || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    instituteName: string().required("Please enter institute name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: InstituteFormValues,
    { setSubmitting, resetForm }: FormikHelpers<InstituteFormValues>
  ) => {
    const payload = {
      instituteName: values.instituteName,
    };
    updateinstituteById({ id: selectedInstituteId, body: payload }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Institute
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditinstituteWrapper;
